import { inject, Injectable } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { getBrowserLang, TranslocoService } from '@jsverse/transloco';
import { environment } from '../../../environments/environment';
import { UiStore } from '../../core/store/ui.store';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  translate = inject(TranslocoService);
  uiStore = inject(UiStore);
  dateAdapter = inject(DateAdapter);

  enabledLanguages = environment.enabledLanguages;
  defaultLanguage = environment.defaultLanguage;

  constructor() {
    if (!this.uiStore.lang()) {
      // try to set browser lang, default if not supported
      this.setLanguage(this._getBrowserLang());
    } else {
      this.setLanguage(this.uiStore.lang());
    }
  }

  setLanguage(code: string) {
    if (this.enabledLanguages.includes(code)) {
      this._useLanguage(code);
    } else {
      const browserLanguage = this._getBrowserLang();
      if (this.enabledLanguages.includes(browserLanguage)) {
        this._useLanguage(browserLanguage);
      } else {
        this._useLanguage(this.defaultLanguage);
      }
    }
  }

  private _useLanguage(code: string) {
    this.translate.setActiveLang(code);
    this.uiStore.setLanguage(code);
    this.dateAdapter.setLocale(code);
  }

  private _getBrowserLang() {
    return getBrowserLang() || this.defaultLanguage;
  }
}
